import React from 'react';
import {AdRequestProffer} from '../../ext/lib/types';
import {displayJsonDate} from '../../ext/lib/temporal';
import {displayAdCost} from '../../ext/billing';

type ReviewProps = {
  adRequest: AdRequestProffer
}

const Review: React.FC<ReviewProps> = props => {
  const adRequest = props.adRequest;
  return (
    <>
      These are your ad details. Are you ready to submit?
      <ul>
        <li><label>Contact name:</label>&nbsp;{adRequest.userFirstName}&nbsp;{adRequest.userLastName}</li>
        <li><label>Ad name:</label>&nbsp;{adRequest.adName}</li>
        <li><label>Organization:</label>&nbsp;{adRequest.organization}</li>
        {(adRequest.rechargeNumber) ? <li><label>Recharge #:</label>&nbsp;{adRequest.rechargeNumber}</li> : ''}
        <li><label>Slide count:</label>&nbsp;{adRequest.slideCount}</li>
        <li style={{overflowWrap: 'anywhere'}}><label>Comments:</label><br/>{adRequest.comments}</li>
        <li><label>Locations:</label>&nbsp;{adRequest.locations.join(', ')}</li>
        <li><label>Run dates:</label>&nbsp;{displayJsonDate(adRequest.firstDate)}&nbsp;&mdash;&nbsp;{displayJsonDate(adRequest.lastDate)}</li>
        <li><label>Cost:</label>&nbsp;{displayAdCost(adRequest)}</li>
      </ul>
    </>
  );
};
export default Review;
